import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import ProductList from "../components/products/product_list"
import { MDXProvider } from "@mdx-js/react"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { Link } from "gatsby"
import Img from "gatsby-image"
import Serb2bPromo from "../components/serb2b_promo"

import Pagination from "../components/pagination/pagination"


const shortcodes = { Link }

export default function Template({
    data, // this prop will be injected by the GraphQL query below.
}) {
    const { mdx } = data // data.markdownRemark holds your post data
    const { frontmatter, body } = mdx
    return (
        <Layout>
            <SEO title={frontmatter.title} />
            <div id="cozumler" className="inlinePage footerFixed">
                <div className="container-fluid w80">
                    <div className="row">
                        <Pagination parent={frontmatter.category} goto={`/${frontmatter.category}`}  here={frontmatter.title} />
                        <div className="w20 left pt0 mt25 col-sm-none pr45">
                            <ProductList />
                        </div>
                        <div className="w80 col-sm-w100 left bl1 bc1 col-sm-bl0 col-sm-pl0 pt0 mt25 pl45">

                            <div className="blog-post-container">
                                <div className="blog-post">
                                    <h1>{frontmatter.title}</h1>
                                </div>

                                <div className="row">
                                    <div className="col-md-8">
                                        <MDXProvider components={shortcodes}>
                                            <MDXRenderer>{body}</MDXRenderer>
                                        </MDXProvider>
                                    </div>
                                    <div className="col-md-4">
                                        <Img className="mb0" fluid={frontmatter.featuredImage.childImageSharp.fluid} alt={frontmatter.title} title={frontmatter.title} />
                                    </div>

                                </div>

                                {frontmatter.path.includes("ser-b2b") && (
                                    <div className="mt25">
                                        <Serb2bPromo />
                                    </div>
                                )}

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export const pageQuery = graphql`
  query($path: String!) {
    mdx(frontmatter: { path: { eq: $path } }) {
      body
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
        category
        featuredImage {
            childImageSharp {
              fluid(maxWidth: 400) {
                ...GatsbyImageSharpFluid
              }
            }
        }
      }
    }
  }
`